import { render, staticRenderFns } from "./NlpBlockCoins.vue?vue&type=template&id=6f5b243a&scoped=true"
import script from "./NlpBlockCoins.vue?vue&type=script&lang=js"
export * from "./NlpBlockCoins.vue?vue&type=script&lang=js"
import style0 from "./NlpBlockCoins.vue?vue&type=style&index=0&id=6f5b243a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b243a",
  null
  
)

export default component.exports